import gsap from 'gsap'

import { utils, store } from '@/core'
import { lenis } from '../app'

const { qs, qsa } = utils
const { dom, device } = store

export default function () {

    const burgerMenu = qs('.burger')
    const jsCloseItems = qsa('.menu-item')
    const subMenu = qsa('.menu_mobile .sub-menu')
    const subMenues = qsa('.menu_mobile .submenu')

    burgerMenu && 
    burgerMenu.addEventListener('click', ()=>{
        burgerMenu.classList.toggle('open')
        if(burgerMenu.classList.contains('open')){
            openMenu()
        }else{
            closeMenu()

        }
    })

    jsCloseItems.forEach(e => e.addEventListener('click', ()=> burgerMenu.classList.contains('open') && closeMenu() ))

    subMenu.forEach( sb => sb.addEventListener('click', ()=>{
        if(sb.querySelector('.submenu').style.display !== 'block'){
            subMenues.forEach( s => s.style.display = "none")
            sb.querySelector('.submenu').style.display = "block"
        }else{
            subMenues.forEach( s => s.style.display = "none")
        }
    }))

    function closeMenu(){
       // console.log('cierra')
        qs('nav').classList.add('hide')
        qs('.burger').classList.remove('open')

        qs('body').style.overflowY='initial'
        //lenis.start()
    }
    function openMenu(){
       // console.log('abre')
        qs('nav').classList.remove('hide')
        qs('body').style.overflowY='hidden'
        //lenis.stop()

    }
}